document.addEventListener('change', (e) => {
  const radio = e.target;
  if (radio.tagName !== 'INPUT' || radio.type !== 'radio') return;

  const source = radio.closest('variant-radios');
  if (!source) return;

  document.querySelectorAll('variant-radios').forEach((instance) => {
    if (instance === source) return;
    const match = instance.querySelector(`input[value="${CSS.escape(radio.value)}"]`);
    if (match) match.checked = true;
  });
});